<template>
    <b-row>
        <b-col md="12">
            <component-header
                title="View Return & Cancellation Policy"
                :hasSearch="false"
                :hasCreate="false"
                :hasClear="false"
                :hasReload="false"
                :hasback="true"
                @back-press="$router.push({ path: '/setup/policy' })"
            />
        </b-col>
        <b-col md="12">
            <b-card class="custome-card">
                <form>
                    <b-row>
                        <b-col md="6" class="mt-2">
                            <label for="productType">Product Type</label>
                            <multiselect
                                v-model="productType"
                                tag-placeholder="Add this as new product type"
                                placeholder="Select Product Type"
                                label="name"
                                :options="productTypeList"
                                track-by="_id"
                                :multiple="true"
                                :taggable="false"
                                :open-direction="'bottom'"
                                disabled
                            ></multiselect>
                            <span class="validate-error">{{ errors[0] }}</span>
                        </b-col>
                        <b-col md="6" class="mt-2">
                            <label for="planName"
                                >Return & Replacement Window Days</label
                            >
                            <b-form-input
                                id="planName"
                                inputType="text"
                                placeholder="Enter Return Window(in days)"
                                v-model="returnWindow"
                                disabled
                            />
                            <span class="validate-error">{{ errors[0] }}</span>
                        </b-col>
                        <b-col md="4" class="mt-4">
                            <v-switch
                                class="pt-1 float-left switch-adjustment-class"
                                color="indigo"
                                label="Allow Return"
                                v-model="allowReturn"
                                disabled
                            >
                            </v-switch>
                        </b-col>
                        <b-col md="4" class="mt-4">
                            <v-switch
                                disabled
                                class="pt-1 float-left switch-adjustment-class"
                                color="indigo"
                                label="Allow Replacement"
                                v-model="allowReplacement"
                            >
                            </v-switch>
                        </b-col>

                        <!-- <b-col md="6" class="mt-4">
                            <label for="planName">Replacement Window</label>
                            <b-form-input
                                id="planName"
                                inputType="text"
                                placeholder="Enter Replacement Window(in days)"
                                v-model="replacementWindow"
                                disabled
                            />
                            <span class="validate-error">{{ errors[0] }}</span>
                        </b-col> -->
                        <b-col md="4" class="mt-4">
                            <v-switch
                                class="pt-1 float-left switch-adjustment-class"
                                color="indigo"
                                label="Return Approval Require"
                                v-model="returnApproval"
                                disabled
                            >
                            </v-switch>
                        </b-col>
                        <b-col md="6">
                            <b-form-group class="mt-2 ml-3">
                                <label>Refund Mode</label>
                                <b-form-checkbox-group
                                    id="refund-mode-group"
                                    v-model="selectedRefundMode"
                                    :options="refundModeOptions"
                                    name="refund-modes"
                                ></b-form-checkbox-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group class="mt-2 ml-3">
                                <label>Allow Cancellation</label>
                                <b-form-radio-group
                                    id="radio-group-2"
                                    v-model="selectedCancellation"
                                    disabled
                                >
                                    <b-form-radio value="BEFORE_APPROVAL"
                                        >Before Approval</b-form-radio
                                    >
                                    <b-form-radio value="BEFORE_DELIVERY"
                                        >Before Delivery</b-form-radio
                                    >
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <label>Note</label>
                            <textarea
                                rows="4"
                                cols="30"
                                id="title"
                                class="form-control custom-transform-class"
                                inputType="text"
                                maxlength="300"
                                v-model="note"
                                disabled
                            ></textarea>
                        </b-col>
                    </b-row>
                </form>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader/index.vue";
import { mapState } from "vuex";
export default {
    name: "View Return Policy",
    data() {
        return {
            productType: "",
            productTypeList: [],
            allowReturn: false,
            allowReplacement: false,
            returnWindow: "",
            replacementWindow: "",
            returnApproval: false,
            refundMode: "",
            allowCancelation: "",
            note: "",
            selectedRefundMode: [],
            selectedCancellation: null,
            refundModeOptions: [
                { text: "Original Payment", value: "ORIGINAL" },
                { text: "Wallet", value: "WALLET" },
            ],
        };
    },
    components: {
        ComponentHeader,
        ebButton,
    },
    computed: {
        ...mapState({
            getPolicyById: (state) => state.returnPolicy.returnPolicyDetails,
        }),
    },
    watch: {
        getPolicyById: {
            immediate: true,
            handler(val) {
                if (val && val.length) {
                    const policy = val[0];
                    this.assignPolicyValues(policy);
                }
            },
        },
        productTypeList(val) {
            // If policy is already loaded when productTypeList arrives
            if (this.getPolicyById && this.getPolicyById.length) {
                const policy = this.getPolicyById[0];
                this.productType = this.productTypeList.filter((item) =>
                    policy.catalogId.includes(item._id),
                );
            }
        },
    },
    methods: {
        async productList() {
            let res = await this.$store.dispatch(
                "catalog/fetchCatalogDataByParam",
                "",
            );
            this.productTypeList = res.data.response.filter(
                (x) => x.isProductType === true,
            );
        },
        async fetchPolicyDetails() {
            try {
                await this.$store.dispatch(
                    "returnPolicy/viewReturnPolicy",
                    this.$route.params.id,
                );
            } catch (error) {
                this.$toasted.error("Unable to fetch data");
            }
        },
        assignPolicyValues(policy) {
            if (this.productTypeList.length) {
                this.productType = this.productTypeList.filter((item) =>
                    policy.catalogId.includes(item._id),
                );
            }
            this.allowReturn = policy.allowReturn;
            this.allowReplacement = policy.allowReplacement;
            this.returnWindow = policy.returnWindowDays;
            this.replacementWindow = policy.replacementWindowDays;
            this.returnApproval = policy.approvalRequired;
            this.selectedRefundMode = policy.refundMode;
            this.selectedCancellation =
                policy.allowCancellation === "BEFORE_APPROVAL"
                    ? "BEFORE_APPROVAL"
                    : "BEFORE_DELIVERY";
            this.note = policy.notes;
        },
    },

    mounted() {
        this.fetchPolicyDetails();
        this.productList();
    },
};
</script>
<style scoped>
.radio-align {
    margin-top: 2px !important;
}
.multiselect__select {
    position: absolute;
    width: 40px;
    height: 41px !important;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    text-align: center;
    transition: transform 0.2s ease;
}
</style>
